import React, { useState, useEffect, useRef } from "react";
import "./Fpm.css";
import {
  Box,
  Grid,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { KeyboardDoubleArrowDown } from "@mui/icons-material";
import { useSelector } from "react-redux";
import Bank from "../images/fsp_banks.png";
import Coop from "../images/fsp_cooperatives.png";
import DFS from "../images/fsp_digital-financial-service-providers.png";
import Insur from "../images/fsp_insurance-companies.png";
import Lend from "../images/fsp_lending-and-finance-companies.png";
import Micro from "../images/fsp_microfinance-non-governmental-organizations.png";
import Mutual from "../images/fsp_mutual-benefit-associations.png";
import ReactToPrint from "react-to-print";
import { useNavigate } from "react-router-dom";

function FpmPage5() {
  const [myArray, setMyArray] = useState([]);
  const [anti, setAnti] = useState(0);
  const [bnkTotal, setBnkTotal] = useState();
  const [coopTotal, setCoopTotal] = useState();
  const [microTotal, setMicroTotal] = useState();
  const [lfTotal, setLFTotal] = useState();
  const [imTotal, setIMTotal] = useState();
  const [maTotal, setMATotal] = useState();
  const [digiTotal, setDigiTotal] = useState();
  const printRef = useRef();
  const [maxScore, setMaxScore] = useState(0);
  const navigate = useNavigate();
  let TRows = [];

  const {
    question1,
    sCheck1,
    sCheck2,
    sCheck3,
    sCheck4,
    sCheck5,
    sCheck6,
    sCheck7,
    sCheck8,
    sCheck9,
    sCheck9Text,
    fspType,
    q3Check1,
    q3Check2,
    q3Check3,
    q3Check4,
    q3Check5,
    q3Check6,
    q3Check7,
    bnkState,
    coopState,
    microState,
    lfState,
    imState,
    maState,
    digiState,
    bnkRank,
    coopRank,
    microRank,
    lfRank,
    imRank,
    maRank,
    digiRank,
    lCheck1,
    lCheck2,
    lCheck3,
    lCheck4,
    lCheck5,
    lCheck6,
    lCheck7,
    lCheck8,
    lCheck9,
    lCheck10,
    lCheck11,
    iCheck1,
    iCheck2,
    iCheck3,
    iCheck4,
    iCheck5,
    iCheck6,
    iCheck7,
    iCheck8,
    iCheck9,
    iCheck10,
    iCheck11,
  } = useSelector((state) => state.fpm);

  const savingsTableData = () => {
    if (sCheck1 === true) {
      TRows = [...TRows, "Initial deposit to open an account (PHP)"];
    }
    if (sCheck2 === true) {
      TRows = [...TRows, "Requirements to open an account"];
    }
    if (sCheck3 === true) {
      TRows = [...TRows, "Maintaining balance (PHP)"];
    }
    if (sCheck4 === true) {
      TRows = [...TRows, "Interest on deposit (%, annually)"];
    }
    if (sCheck5 === true) {
      TRows = [...TRows, "Amount of deposit to earn interest (PHP)"];
    }
    if (sCheck6 === true) {
      TRows = [...TRows, "Withdrawal Process"];
    }
    if (sCheck7 === true) {
      TRows = [...TRows, "Deposit insurance"];
    }
    if (sCheck8 === true) {
      TRows = [...TRows, "Fees and charges (PHP)"];
    }
    if (sCheck9 === true) {
      TRows = [...TRows, sCheck9Text];
    }

    const filteredArray = TRows.filter((item, index) => {
      // Check if the item's index is the first occurrence in the array
      return TRows.indexOf(item) === index;
    });

    setMyArray(filteredArray);
  };

  const loansTableData = () => {
    if (lCheck1 === true) {
      TRows = [...TRows, "Loan amount (PHP)"];
    }
    if (lCheck2 === true) {
      TRows = [...TRows, "Requirements to get a loan"];
    }
    if (lCheck3 === true) {
      TRows = [
        ...TRows,
        "Bundled financial product (e.g., savings, insurance)",
      ];
    }
    if (lCheck4 === true) {
      TRows = [
        ...TRows,
        "Repayment mode and regular principal amount (e.g. PHP 1,000 per month)",
      ];
    }
    if (lCheck5 === true) {
      TRows = [...TRows, "Interest rate (%, monthly)"];
    }
    if (lCheck6 === true) {
      TRows = [...TRows, "Effective Interest Rate (EIR, %, annually)"];
    }
    if (lCheck7 === true) {
      TRows = [...TRows, "Other fees and charges (PHP)"];
    }
    if (lCheck8 === true) {
      TRows = [
        ...TRows,
        "Bundled non-financial products at no cost to clients (e.g. financial education, skills training, etc.)",
      ];
    }
    if (lCheck9 === true) {
      TRows = [...TRows, "Collateral"];
    }
    if (lCheck10 === true) {
      TRows = [...TRows, "Repayment term"];
    }
    if (lCheck11 === true) {
      TRows = [...TRows, sCheck9Text];
    }

    const filteredArray = TRows.filter((item, index) => {
      // Check if the item's index is the first occurrence in the array
      return TRows.indexOf(item) === index;
    });

    setMyArray(filteredArray);
  };

  const insuranceTableData = () => {
    if (iCheck1 === true) {
      TRows = [...TRows, "Total premium to be paid (PHP)"];
    }
    if (iCheck2 === true) {
      TRows = [...TRows, "Delivery channel- to claim"];
    }
    if (iCheck3 === true) {
      TRows = [...TRows, "Payment term"];
    }
    if (iCheck4 === true) {
      TRows = [
        ...TRows,
        "Mode of payment and amount of premium on installment",
      ];
    }
    if (iCheck5 === true) {
      TRows = [...TRows, "Requirement to buy a policy"];
    }
    if (iCheck6 === true) {
      TRows = [...TRows, "Delivery channel- to buy an insurance policy"];
    }
    if (iCheck7 === true) {
      TRows = [...TRows, "Delivery channel- to pay the regular premium"];
    }
    if (iCheck8 === true) {
      TRows = [...TRows, "Amount of coverage"];
    }
    if (iCheck9 === true) {
      TRows = [...TRows, "Requirements when filing claim"];
    }
    if (iCheck10 === true) {
      TRows = [...TRows, "Average number of days to settle claim"];
    }
    if (iCheck11 === true) {
      TRows = [...TRows, sCheck9Text];
    }

    const filteredArray = TRows.filter((item, index) => {
      // Check if the item's index is the first occurrence in the array
      return TRows.indexOf(item) === index;
    });

    setMyArray(filteredArray);
  };

  const getTotalRanks = () => {
    const BnkNum = bnkRank.map((str) => {
      return parseInt(str, 12);
    });

    setBnkTotal(
      BnkNum.reduce((total, currentItem) => (total = total + currentItem), 0)
    );

    const CoopNum = coopRank.map((str) => {
      return parseInt(str, 12);
    });
    setCoopTotal(
      CoopNum.reduce((total, currentItem) => (total = total + currentItem), 0)
    );

    const MicroNum = microRank.map((str) => {
      return parseInt(str, 12);
    });
    setMicroTotal(
      MicroNum.reduce((total, currentItem) => (total = total + currentItem), 0)
    );

    const LFNum = lfRank.map((str) => {
      return parseInt(str, 12);
    });
    setLFTotal(
      LFNum.reduce((total, currentItem) => (total = total + currentItem), 0)
    );

    const IMNum = imRank.map((str) => {
      return parseInt(str, 12);
    });
    setIMTotal(
      IMNum.reduce((total, currentItem) => (total = total + currentItem), 0)
    );

    const MANum = maRank.map((str) => {
      return parseInt(str, 12);
    });
    setMATotal(
      MANum.reduce((total, currentItem) => (total = total + currentItem), 0)
    );

    const DigiNum = digiRank.map((str) => {
      return parseInt(str, 12);
    });
    setDigiTotal(
      DigiNum.reduce((total, currentItem) => (total = total + currentItem), 0)
    );
  };

  const [firstPlace, setFirstPlace] = useState([]);
  const [secondPlace, setSecondPlace] = useState([]);

  const getRankPlacement = () => {
    const data = [
      { name: "Banks", value: bnkTotal, img: Bank },
      { name: "Cooperatives", value: coopTotal, img: Coop },
      {
        name: "Digital Financial Service Providers",
        value: digiTotal,
        img: DFS,
      },
      { name: "Insurance Companies", value: imTotal, img: Insur },
      { name: "Lending and Finance Companies", value: lfTotal, img: Lend },
      { name: "Microfinance NGOs", value: microTotal, img: Micro },
      { name: "Mutual Benefit Associations", value: maTotal, img: Mutual },
    ];

    data.sort((a, b) => b.value - a.value);

    // Determine 1st place values
    const firstPlaceValue = data[0].value;

    // Filter first place data
    const firstPlaceData = data.filter(
      (item) => item.value === firstPlaceValue
    );

    // Check if all items have the same value (1st place)
    const allItemsAreSame = data.every(
      (item) => item.value === firstPlaceValue
    );

    // If all items are the same, set second place as empty
    const secondPlaceData = allItemsAreSame ? [] : data.slice(1, 2);

    // Set the state variables for 1st and 2nd place
    setFirstPlace(firstPlaceData);
    setSecondPlace(secondPlaceData);
  };

  useEffect(() => {
    getTotalRanks();
    getRankPlacement();
    setAnti(0);
    getMaxScore();
  }, [firstPlace, secondPlace, anti]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (fspType === "Savings") {
      savingsTableData();
    }
    if (fspType === "Loans") {
      loansTableData();
    }
    if (fspType === "Insurance") {
      insuranceTableData();
    }
  }, [anti]);

  const handleTools = () => {
    window.location.replace("https://aralplus.ph/quick-learning-tools");
  };

  const handleChoice = () => {
    window.location.replace("https://aralplus.ph/choice-module");
  };

  const handleVids = () => {
    window.location.replace("https://aralplus.ph");
  };

  const getMaxScore = () => {
    const boolVars = [
      q3Check1,
      q3Check2,
      q3Check3,
      q3Check4,
      q3Check5,
      q3Check6,
      q3Check7,
    ];
    const trueCount = boolVars.filter((value) => value === true).length;
    const rowCOunt = myArray.length;
    const max = trueCount * rowCOunt;
    setMaxScore(max);
  };

  return (
    <Box sx={{ backgroundColor: "#ffffff", height: "100vh" }}>
      <Box className="main-result-card" ref={printRef}>
        <div className="print-1stPage">
          <Box className="header-text-result">
            <p>The</p>
            <p style={{ textDecoration: "underline" }}> Most Suitable</p>
            <p> FSP for you</p>
          </Box>

          <Box
            sx={{
              width: "13%",
              marginTop: "1rem",
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              gap: "2rem",
            }}
          >
            {firstPlace.length > 0
              ? firstPlace.map((item, index) => (
                  <img
                    key={item.img}
                    src={item.img}
                    alt="FSP"
                    style={{ width: "100%", objectFit: "contain" }}
                  />
                ))
              : "No option available"}
          </Box>
          <Box>
            <h2 style={{ color: "#06BCEE" }}>
              {firstPlace.length > 0
                ? firstPlace.map((item, index) => (
                    <span key={item.name}>
                      {index > 0 && index === firstPlace.length - 1
                        ? " and "
                        : index > 0
                        ? ", "
                        : ""}
                      {item.name}
                    </span>
                  ))
                : "No option available"}
            </h2>
          </Box>

          <Box className="result-text-main">
            <p>
              Based on your scoring,
              {firstPlace.length > 0
                ? firstPlace.map((item, index) => (
                    <span key={item.name}>
                      {index > 0 && index === firstPlace.length - 1
                        ? " and "
                        : index > 0
                        ? ", "
                        : ""}
                      {item.name}
                    </span>
                  ))
                : "No option available"}{" "}
              had the highest score of {firstPlace[0]?.value}/{maxScore}, which
              is the most suitable option for your needs right now.
            </p>
          </Box>
          <Box className="header-text-result" sx={{ marginTop: "2rem" }}>
            <p style={{ textDecoration: "underline" }}>2nd Most Suitable</p>
          </Box>
          <Box sx={{ width: "13%", marginTop: "1rem" }}>
            {secondPlace.length > 0
              ? secondPlace.map((item, index) => (
                  <img
                    key={item.img}
                    src={item.img}
                    alt="FSP"
                    style={{ width: "100%", objectFit: "contain" }}
                  />
                ))
              : "No option available"}
          </Box>
          <Box>
            <h2 style={{ color: "#06BCEE" }}>
              {secondPlace.length > 0
                ? secondPlace.map((item, index) => (
                    <span key={item.name}>
                      {index > 0 && index === secondPlace.length - 1
                        ? " and "
                        : index > 0
                        ? ", "
                        : ""}
                      {item.name}
                    </span>
                  ))
                : "No option available"}
            </h2>
          </Box>
          <Box
            className="scroll-down-text"
            sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
          >
            <Box
              sx={{
                textAlign: "center",
                opacity: "0.3",
              }}
            >
              <h2>Scroll down for more</h2>
              <KeyboardDoubleArrowDown
                sx={{ fontSize: "2rem", fontWeight: "500" }}
              />
            </Box>
          </Box>
        </div>

        <Box className="result-table-card">
          <TableContainer className="fpm---table---container-result">
            <Table size="small" className="fpm---table">
              <TableHead>
                <TableRow className="fpm---table---header2">
                  <TableCell className="fpm---table---cell2" align="center">
                    {fspType}
                  </TableCell>
                  <TableCell
                    className="fpm---table---cell2"
                    align="center"
                    colSpan="100%"
                  >
                    Financial Service Provider (FSP)
                  </TableCell>
                </TableRow>
                <TableRow className="fpm---table---header">
                  <TableCell className="fpm---table---cell2" align="center">
                    Product Terms
                  </TableCell>
                  {q3Check1 === true ? (
                    <TableCell className="fpm---table---cell2" align="center">
                      Bank
                    </TableCell>
                  ) : null}
                  {q3Check2 === true ? (
                    <TableCell className="fpm---table---cell2" align="center">
                      Cooperatives
                    </TableCell>
                  ) : null}
                  {q3Check3 === true ? (
                    <TableCell className="fpm---table---cell2" align="center">
                      Microfinance NGOs
                    </TableCell>
                  ) : null}
                  {q3Check4 === true ? (
                    <TableCell className="fpm---table---cell2" align="center">
                      Lending and Finance Companies
                    </TableCell>
                  ) : null}
                  {q3Check5 === true ? (
                    <TableCell className="fpm---table---cell2" align="center">
                      Insurance Companies
                    </TableCell>
                  ) : null}
                  {q3Check7 === true ? (
                    <TableCell className="fpm---table---cell2" align="center">
                      Mutual Benefit Associations
                    </TableCell>
                  ) : null}
                  {q3Check6 === true ? (
                    <TableCell className="fpm---table---cell2" align="center">
                      Digital FPS
                    </TableCell>
                  ) : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {myArray.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell className="fpm---table---cell1">{row}</TableCell>
                    {q3Check1 === true ? (
                      <TableCell className="fpm---table---cell">
                        <Grid
                          container
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Grid item xs={6}>
                            <Box>
                              <TextField
                                defaultValue={bnkState[index]}
                                sx={{ maxWidth: "15rem" }}
                                variant="standard"
                                InputProps={{
                                  disableUnderline: true,
                                  readOnly: true,
                                }}
                              />
                            </Box>
                          </Grid>

                          <Grid item xs={6} textAlign="center">
                            <Box className="fpm--results--rank--container">
                              {bnkRank[index]}
                            </Box>
                          </Grid>
                        </Grid>
                      </TableCell>
                    ) : null}
                    {q3Check2 === true ? (
                      <TableCell className="fpm---table---cell">
                        <Grid container>
                          <Grid item xs={6}>
                            <TextField
                              defaultValue={coopState[index]}
                              sx={{ maxWidth: "15rem" }}
                              variant="standard"
                              InputProps={{
                                disableUnderline: true,
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={6} textAlign="center">
                            <Box className="fpm--results--rank--container">
                              {coopRank[index]}
                            </Box>
                          </Grid>
                        </Grid>
                      </TableCell>
                    ) : null}
                    {q3Check3 === true ? (
                      <TableCell className="fpm---table---cell">
                        <Grid container>
                          <Grid item xs={6}>
                            <TextField
                              defaultValue={microState[index]}
                              sx={{ maxWidth: "15rem" }}
                              variant="standard"
                              InputProps={{
                                disableUnderline: true,
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={6} textAlign="center">
                            <Box className="fpm--results--rank--container">
                              {microRank[index]}
                            </Box>
                          </Grid>
                        </Grid>
                      </TableCell>
                    ) : null}
                    {q3Check4 === true ? (
                      <TableCell className="fpm---table---cell">
                        <Grid container>
                          <Grid item xs={6}>
                            <TextField
                              defaultValue={lfState[index]}
                              sx={{ maxWidth: "15rem" }}
                              variant="standard"
                              InputProps={{
                                disableUnderline: true,
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={6} textAlign="center">
                            <Box className="fpm--results--rank--container">
                              {lfRank[index]}
                            </Box>
                          </Grid>
                        </Grid>
                      </TableCell>
                    ) : null}
                    {q3Check5 === true ? (
                      <TableCell className="fpm---table---cell">
                        <Grid container>
                          <Grid item xs={6}>
                            <TextField
                              defaultValue={imState[index]}
                              sx={{ maxWidth: "15rem" }}
                              variant="standard"
                              InputProps={{
                                disableUnderline: true,
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={6} textAlign="center">
                            <Box className="fpm--results--rank--container">
                              {imRank[index]}
                            </Box>
                          </Grid>
                        </Grid>
                      </TableCell>
                    ) : null}
                    {q3Check7 === true ? (
                      <TableCell className="fpm---table---cell">
                        <Grid container>
                          <Grid item xs={6}>
                            <TextField
                              defaultValue={maState[index]}
                              sx={{ maxWidth: "15rem" }}
                              variant="standard"
                              InputProps={{
                                disableUnderline: true,
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={6} textAlign="center">
                            <Box className="fpm--results--rank--container">
                              {maRank[index]}
                            </Box>
                          </Grid>
                        </Grid>
                      </TableCell>
                    ) : null}
                    {q3Check6 === true ? (
                      <TableCell className="fpm---table---cell">
                        <Grid container>
                          <Grid item xs={6}>
                            <TextField
                              defaultValue={digiState[index]}
                              sx={{ maxWidth: "15rem" }}
                              variant="standard"
                              InputProps={{
                                disableUnderline: true,
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={6} textAlign="center">
                            <Box className="fpm--results--rank--container">
                              {digiRank[index]}
                            </Box>
                          </Grid>
                        </Grid>
                      </TableCell>
                    ) : null}
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell className="fpm---table---cell4">
                    Total Score{" "}
                  </TableCell>
                  {q3Check1 === true ? (
                    <TableCell className="fpm---table---cell3">
                      <Box className="fpm--results--total--container">
                        {bnkTotal}
                      </Box>
                    </TableCell>
                  ) : null}
                  {q3Check2 === true ? (
                    <TableCell className="fpm---table---cell3">
                      <Box className="fpm--results--total--container">
                        {coopTotal}
                      </Box>
                    </TableCell>
                  ) : null}
                  {q3Check3 === true ? (
                    <TableCell className="fpm---table---cell3">
                      <Box className="fpm--results--total--container">
                        {microTotal}
                      </Box>
                    </TableCell>
                  ) : null}
                  {q3Check4 === true ? (
                    <TableCell className="fpm---table---cell3">
                      <Box className="fpm--results--total--container">
                        {lfTotal}
                      </Box>
                    </TableCell>
                  ) : null}
                  {q3Check5 === true ? (
                    <TableCell className="fpm---table---cell3">
                      <Box className="fpm--results--total--container">
                        {imTotal}
                      </Box>
                    </TableCell>
                  ) : null}
                  {q3Check7 === true ? (
                    <TableCell className="fpm---table---cell3">
                      <Box className="fpm--results--total--container">
                        {maTotal}
                      </Box>
                    </TableCell>
                  ) : null}
                  {q3Check6 === true ? (
                    <TableCell className="fpm---table---cell3">
                      <Box className="fpm--results--total--container">
                        {digiTotal}
                      </Box>
                    </TableCell>
                  ) : null}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box className="fpm__button__container">
            <ReactToPrint
              trigger={() => (
                <Button
                  className="fpm--button"
                  sx={{ width: "20rem", marginBottom: "5rem" }}
                >
                  Print
                </Button>
              )}
              content={() => printRef.current}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
          className="footer-result-container"
        >
          <Box className="text-container">
            <p className="header-text-2" style={{ width: "600px" }}>
              Check out the following to help you improve your empowerment level
              in the Choice dimensions:
            </p>
          </Box>
          <Box className="text-container-2">
            <p className="link-text" onClick={() => handleChoice()}>
              Choice Module
            </p>
          </Box>
          <Box className="text-container-2">
            <p className="link-text" onClick={() => handleVids()}>
              Videos of an Empowered Filipino Customer
            </p>
          </Box>
          <Box className="text-container-2" sx={{ marginBottom: "3rem" }}>
            <p className="link-text" onClick={() => handleTools()}>
              Other Quick Learning Tools
            </p>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default FpmPage5;
